module.exports = __webpack_public_path__ + "static/media/scrollUpArrow.42b2d611.gif";